<app-loader-circles *ngIf="showLoader"></app-loader-circles>
<form [formGroup]="form" class="forms">
  <div class="content">
    <h2 style="padding-left: 5px">Resultado Parcial</h2>
    <div class="row">
      <div class="col-xs-12 text-right">
        <ul class="list-inline options">
          <li style="padding-right: 0">
            <a
              class="icon-full"
              style="padding-top: 6px"
              (click)="abrirModalProdutos()"
            >
              <em class="fa fa-gear"></em>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="panel-content">
      <div class="content-header">
        <div class="header-title">Valor Solicitado</div>
        <div class="header-content">
          <div class="icone icon-patrimonio"></div>
          <div>
            {{
              form.get('valorFinanciamento').value || 0.0
                | currency: 'BRL':'symbol':'1.2-2'
            }}
          </div>
        </div>
      </div>
      <app-btn-small
        class="btn-between"
        color="primary"
        (click)="abrirModalAlterarValor()"
        style="left: 295px"
      >
        Alterar Valor
      </app-btn-small>
      <app-btn-small
        class="btn-between"
        color="secondary"
        (click)="abrirModalTabelas()"
        style="left: 410px"
      >
        Tabela
      </app-btn-small>
      <div class="content-body repique" *ngIf="valorDivida">
        <div class="centered column-direction">
          <label class="label-valor-liberado">Valor Liberado</label>
          <label class="valor-liberado">{{
            valorLiberado | currency: 'BRL':'symbol':'1.2-2'
          }}</label>
          <label class="valor-divida"
            >Valor da dívida:
            {{ valorDivida | currency: 'BRL':'symbol':'1.2-2' }}</label
          >
        </div>
      </div>
      <div class="content-body">
        <div class="calculo-title">Opções de parcelamento</div>
        <div class="body-content">
          <parcela
            [formParent]="form"
            [parcelaMax]="parcelaMax"
            [parcelas]="parcelas"
          ></parcela>
          <div *ngIf="simulacao"  class="simulacao-operation">
           {{propostaSimulacao.simulacao.operation.description}}
          </div>
          <div class="panel-actions">
            <app-btn-small color="primary">
              <calendar
                [titleCalendar]="'Data para pagamento'"
                [startDate]="propostaSimulacao.simulacao.gracePeriodRange.from"
                [endDate]="propostaSimulacao.simulacao.gracePeriodRange.to"
                [dateSelected]="propostaSimulacao.simulacao.primeiraParcela"
                (dateSelectedChange)="onChangePrimeiraParcela($event)"
                [restrictDates]="true"
                [validDays]="propostaSimulacao.proposta.diasValidosVencimento"
              >
                <em class="fa fa-calendar"></em>
                Vencimento:
                {{
                  (propostaSimulacao.simulacao.primeiraParcela * 1000
                    | date: 'dd/MM/yyyy') || 'Selecione uma data'
                }}
              </calendar>
            </app-btn-small>
            <app-btn-small
              *ngIf="
                propostaSimulacao.proposta.transients.parcela &&
                propostaSimulacao.proposta.transients.parcela.valorRetido
              "
              (click)="abrirModalRetencao()"
              color="secondary"
              title="Retenção"
            >
              <em class="fa fa-money"></em>
            </app-btn-small>
          </div>
          <div
            class="col-xs-12"
            *ngIf="!!!propostaSimulacao.simulacao.primeiraParcela"
          >
            <div class="alert alert-danger alert-dismissable">
              <strong>Vencimento é obrigatório</strong> é necessário selecionar
              uma uma data para o vencimento!
            </div>
          </div>
        </div>
      </div>
      <div class="content-footer" (click)="abrirModalParcelaPersonalizada()">
        <a class="content-footer__action">
          <em class="fa fa-plus content-footer__icon"></em>
          Opções de parcelamento
        </a>
      </div>
    </div>
  </div>
</form>
<app-botao-navegacao
  (next)="onClickNext()"
  (previous)="onClickPrevious()"
  [nextLabel]="'Analisar'"
  [previousShow]="simulacao"
  [nextShow]="true"
  [nextEnabled]="
    form.valid && !simulacao && !!propostaSimulacao?.simulacao?.primeiraParcela
  "
>
</app-botao-navegacao>

<div id="retencao" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">RETENÇÃO</h3>
      </div>
      <div class="modal-body">
        <h3>VALOR DA RETENÇÃO</h3>
        <h1 class="modal-retencao-valor">R$ 669,60</h1>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="marginT30 form-group">
            <a
              class="bt-back btn btn-border-orange pull-right"
              data-dismiss="modal"
            >
              Fechar</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
